import { UserStatisticsDto } from '@libs/dto';

import { api } from '../common.api';

export const adminUserApi = api.injectEndpoints({
  endpoints: (build) => ({
    userStatistics: build.query<UserStatisticsDto, void>({
      query: () => ({
        url: '/user/admin/statistics',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useUserStatisticsQuery,
} = adminUserApi; 